import { Button, DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons'
import './CustomButton.scss'
import { useRef } from 'react'

interface IButtonProps {
  fillMode?: 'flat' | 'outline' | 'link' | 'solid',
  themeColor?: 'primary' | 'dark' | 'light' | 'error' | 'success' | 'info' | 'secondary' | 'warning',
  className?: string,
  disabled?: boolean,
  icon?: string,
  children?: any;
  onClick: (item: any) => void;
  title?: string;
  size?: "large" | "medium" | "small"
  isDropdown?: boolean;
  dropdownChildren?: any[];
  onDropdownChildClick?: (event: DropDownButtonItemClickEvent) => void;
  dropdownChildTextField?: string;
}

/**
* @props fillMode 'flat' | 'outline' | 'link' | 'solid',
* @props themeColor?: 'primary' | 'dark' | 'light' | 'error' | 'success' | 'info' | 'secondary' | 'warning',
* @props className?: string,
* @props disabled?: boolean,
* @props icon?: string,
* @props children?: any;
* @props onClick: (item: any) => void;
* @props title?: string;
* @returns Kendo Button
*/
const CustomButton = (props: IButtonProps) => {
  const { 
    fillMode, 
    className, 
    disabled, 
    icon, 
    children, 
    themeColor, 
    isDropdown, 
    dropdownChildren, 
    onDropdownChildClick, 
    dropdownChildTextField 
  } = props;

  const buttonRef = useRef<any>(null);

  const checkEnter = (e: React.KeyboardEvent) =>{
    if(e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      buttonRef.current?.element.click();
    } 
  }

  return (
    <div>
      {!isDropdown && (
        <Button
          ref={buttonRef}
          title={props.title ?? ""}
          fillMode={fillMode ?? 'solid'}
          className={className ?? 'default-button'}
          disabled={disabled ?? false}
          icon={icon ?? ''}
          themeColor={themeColor ?? 'primary'}
          onClick={props.onClick ?? null}
          onKeyDown={checkEnter}
          size={props.size ?? "medium"}
        >
          {children ?? null}
        </Button>
      )}
      {isDropdown && (
        <DropDownButton
          title={props.title ?? ""}
          text={props.title ?? ""}
          fillMode={fillMode ?? 'solid'}
          className={className ?? 'default-button'}
          disabled={disabled ?? false}
          icon={icon ?? ''}
          themeColor={'primary'}
          size={props.size ?? "medium"}
          items={dropdownChildren}
          textField={dropdownChildTextField}
          onItemClick={onDropdownChildClick}
        >
        </DropDownButton>
      )}
    </div>
  )
}

export default CustomButton